// extracted by mini-css-extract-plugin
export default {"root":"CustomEmojiTooltip-module__root","emojiButton":"CustomEmojiTooltip-module__emojiButton"};